import _ from "lodash";
export default class SpatVerificationData {
	id = -1;

	timeReceived = "";

	_dateTimeReceived = new Date();

	get dateTimeReceived() {
		return this._dateTimeReceived;
	}

	set dateTimeReceived(value) {
		this._dateTimeReceived = value;
		this.timeReceived = SpatVerificationData.dateToTimecode(
			this._dateTimeReceived
		);
		this.frameNumber = Math.floor(this._dateTimeReceived.getTime() / 100) * 100;
	}

	frameNumber = 0;

	ipAddress = "";

	minTimeToChange = {
		1: "",
		2: "",
		3: "",
		4: "",
		5: "",
		6: "",
		7: "",
		8: "",
		9: "",
		10: "",
		11: "",
		12: "",
		13: "",
		14: "",
		15: "",
		16: ""
	};

	minEndTime = "";

	timeOfChange = {
		1: "",
		2: "",
		3: "",
		4: "",
		5: "",
		6: "",
		7: "",
		8: "",
		9: "",
		10: "",
		11: "",
		12: "",
		13: "",
		14: "",
		15: "",
		16: ""
	};

	isFake = false;

	lights = {
		1: "C",
		2: "C",
		3: "C",
		4: "C",
		5: "C",
		6: "C",
		7: "C",
		8: "C",
		9: "C",
		10: "C",
		11: "C",
		12: "C",
		13: "C",
		14: "C",
		15: "C",
		16: "C"
	};

	originalData = {};

	constructor(args) {
		if (!args) {
			return;
		}

		if (args["id"]) {
			this.id = args["id"];
		}

		if (args["timeReceived"]) {
			const timeReceived = args["timeReceived"];
			let newDateTimeReceived = new Date();
			newDateTimeReceived.setHours(timeReceived.substr(0, 2));
			newDateTimeReceived.setMinutes(timeReceived.substr(3, 2));
			newDateTimeReceived.setSeconds(timeReceived.substr(6, 2));
			newDateTimeReceived.setMilliseconds(timeReceived.substr(9, 3));
			this.dateTimeReceived = newDateTimeReceived;
		}

		if (args["minEndTime"]) {
			this.minEndTime = args["minEndTime"];
		}

		// Merge the lights, minTimeToChange, timeOfChange
		let index = 1;
		while (index < 17) {
			if (args["lights"] && args["lights"][index]) {
				this.lights[index] = args["lights"][index].toString();
			}
			if (args["minTimeToChange"] && args["minTimeToChange"][index]) {
				this.minTimeToChange[index] = args["minTimeToChange"][index].toString();
			}
			if (args["timeOfChange"] && args["timeOfChange"][index]) {
				this.timeOfChange[index] = args["timeOfChange"][index].toString();
			}
			index++;
		}
	}

	/**
	 * Converts dSeconds past the hour to time string.
	 * @param tenthsSeconds (number)
	 * @param dateTimeReceived (Date)
	 * @returns string
	 */
	// TODO: Double check this conversion.
	convertTenthsSecondsPastHour = function(tenthsSeconds, dateTimeReceived) {
		const secondsPastHour = tenthsSeconds / 10;

		const minuteOfHour = secondsPastHour / 60;
		const minuteOfHourAbs = Math.floor(minuteOfHour);

		const secondOfHour = (minuteOfHour - minuteOfHourAbs) * 60;
		const secondOfHourAbs = Math.floor(secondOfHour);

		const millisOfHour = Math.floor((secondOfHour - secondOfHourAbs) * 100);

		let dateTimeChange = new Date(dateTimeReceived.getTime());
		const dateTimeReceivedSecondsPastHour =
			dateTimeChange.getMinutes() * 60 + dateTimeChange.getSeconds();
		if (secondsPastHour < dateTimeReceivedSecondsPastHour) {
			dateTimeChange.setMinutes(minuteOfHourAbs);
			dateTimeChange.setHours(dateTimeChange.getHours() + 1);
		} else {
			dateTimeChange.setMinutes(minuteOfHourAbs);
		}

		dateTimeChange.setSeconds(Math.floor(secondOfHourAbs));
		dateTimeChange.setMilliseconds(millisOfHour);
		return SpatVerificationData.dateToTimecode(dateTimeChange);
	};

	/**
	 * Converts Date object to hours, minutes, seconds, milliseconds string
	 * @param dateTime (Date)
	 */
	static dateToTimecode = function(dateTime) {
		if (!(dateTime instanceof Date)) {
			return "";
		}

		let hours = dateTime.getHours().toString();
		if (hours.length === 1) {
			hours = "0" + hours;
		}

		let minutes = dateTime.getMinutes().toString();
		if (minutes.length === 1) {
			minutes = "0" + minutes;
		}

		let seconds = dateTime.getSeconds().toString();
		if (seconds.length === 1) {
			seconds = "0" + seconds;
		}

		let millis = dateTime.getMilliseconds().toString();
		if (millis.length === 1) {
			millis = "00" + millis;
		}
		if (millis.length === 2) {
			millis = "0" + millis;
		}
		return `${hours}:${minutes}:${seconds}.${millis}`;
	};

	/**
	 * Determines signal color from movement state value.
	 * @param movementState (number)
	 */
	getSignalColorFromMovementState = function(movementState) {
		if (this.signalStateColors.red.indexOf(movementState) > -1) {
			return "R";
		}
		if (this.signalStateColors.green.indexOf(movementState) > -1) {
			return "G";
		}
		if (this.signalStateColors.yellow.indexOf(movementState) > -1) {
			return "Y";
		}
		return "C";
	};

	/**
	 * Static method to create new SpatVerificationData object from TSC MQTT message.
	 * @param mqttMessage (object)
	 *
	 * @returns SpatVerificationData
	 */
	static parseTscMessage(mqttMessage) {
		const payload = JSON.parse(mqttMessage["message"]["payloadString"]);
		const phaseList = payload["SpatFields"]["PhaseList"];
		let newData = new SpatVerificationData();
		newData.dateTimeReceived = new Date(Date.parse(payload.Timestamp));
		newData.id = payload["SpatFields"]["MsgSeqCounter"];
		newData.ipAddress = payload["Ip"];
		newData.originalData = payload;
		_.each(phaseList, phase => {
			newData.minTimeToChange[
				phase.PhaseNum
			] = phase.VehMinTimeToChange.toString();
			newData.lights[phase.PhaseNum] = phase.PhaseStatusLightStr;
		});
		return newData;
	}

	/**
	 * Static method to create new SpatVerificationData object from RSU MQTT message.
	 * @param mqttMessage (object)
	 *
	 * @return SpatVerificationData
	 */
	static parseRsuMessage(mqttMessage) {
		const payload = JSON.parse(mqttMessage["message"]["payloadString"]);
		// TODO: How do we handle more than one intersection?? SpatFields->Intersections is actually an array.
		// IntersectionId is contained within each Intersection object, and we should
		// use that to determine the particular intersection to parse.
		const movementStates =
			payload["SpatFields"]["Intersections"][0]["MovementStates"];
		let newData = new SpatVerificationData();
		newData.dateTimeReceived = new Date(Date.parse(payload.Timestamp));
		newData.id =
			payload["SpatFields"]["Intersections"][0]["MessageCount"] || "";
		newData.originalData = payload;
		newData.ipAddress = payload["Ip"] || "";
		_.each(movementStates, movementState => {
			const signalGroupId = movementState["SignalGroupId"];

			// Determine min end time
			const movementMinEndTime =
				movementState["MovementEvents"][0]["MinEndTime"];
			newData.timeOfChange[
				signalGroupId
			] = newData.convertTenthsSecondsPastHour(
				movementMinEndTime,
				newData.dateTimeReceived
			);

			// Determine signal color
			const movementPhaseState =
				movementState["MovementEvents"][0]["MovementPhaseState"];
			newData.lights[signalGroupId] = newData.getSignalColorFromMovementState(
				movementPhaseState
			);
		});
		return newData;
	}

	/**
	 * Movement state values for each signal color.
	 * These come from SAE INTERNATIONAL J2735™ MAR2016 Page 161
	 */
	signalStateColors = {
		red: [2, 3],
		green: [4, 5, 6],
		yellow: [7, 8, 9]
	};
}
